// extracted by mini-css-extract-plugin
export default {"postalAddress":"SignDocumentAction_postalAddress","documentTypeFooterLink":"SignDocumentAction_documentTypeFooterLink"};